module.exports = __webpack_public_path__ + "static/images/661b8622.png";